<template>
  <div class="footer">
    <div class="footer-contact">
      <div class="container">
        <div class="content">
          <div class="content-left">
            <span>联系我们</span>
            <span>我们会协助您打造符合您需求的解决方案</span>
          </div>
          <div class="content-right">
            <div class="content-right-item" @click="contactUsVisible = true">
              <div class="desc">
                <span>在线咨询 / 商务对接</span>
                <span>实时沟通解决您的问题和需求</span>
              </div>
              <button class="btn">立即咨询</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="footer-top">
        <img src="/static/img/footer/sys_title.png" width="144" alt="" />
      </div>
      <div class="footer-center">
        <div class="footer-content">
          <div class="footer-content-item">
            <div class="label">
              <span>商务对接</span>
              <span class="tip">（每周一至周五 8:00-17:00）</span>
            </div>
            <div class="value">0571-89978775</div>
          </div>
          <div class="footer-content-item">
            <div class="label">
              <span>技术支持</span>
              <span class="tip">（每周一至周五 8:00-17:00）</span>
            </div>
            <div class="value">0571-89978771</div>
          </div>
          <div class="footer-content-item">
            <div class="label">
              <span>电子邮箱</span>
            </div>
            <div class="value">smarthse@smarthse.cn</div>
          </div>
          <div class="footer-content-item">
            <div class="label">
              <span>公司地址</span>
            </div>
            <div class="value">浙江省·杭州市·上城区·笕桥街道·笕丁路168号·大世界五金城32幢-511/509</div>
          </div>
        </div>
        <div class="footer-code">
          <img src="/static/img/footer/QR_code.png" width="100" alt="" />
          <div>
            关注公众号
            <br />
            获取最新动态
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-content">
          <div>
            <img src="/static/img/footer/icon_filings.png" width="19" alt="" />
            <span>增值电信业务经营许可证：浙B2-20170059&nbsp;&nbsp;</span>
          </div>
          <a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备16005120号-2&nbsp;&nbsp;</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602005885">浙公网安备33010602005885号&nbsp;&nbsp;</a>
          <span>©智慧职安环保科技有限公司版权所有</span>
        </div>
        <div class="footer-service">
          <router-link to="/fwtk" >服务条款</router-link>
          <span class="divider"></span>
          <router-link to="/yssm" >隐私声明</router-link>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="contactUsVisible"
      width="600px"
      custom-class="contact-us-dialog"
      append-to-body
    >
      <p class="title">联系我们</p>
      <p class="desc">深耕EHS领域，业务范围覆盖职业健康、放射卫生、安全生产等场景。</p>
      <p class="desc">
        无论您是监管部门、还是用人单位，
        <br />
        我们都能为您量身定制数智化方案。留下信息，让我们帮您解决问题。
      </p>
      <p class="text-fill-blue">期待与您合作</p>
      <div class="item">
        <div class="item-left">
          <span>在线咨询</span>
          <span>实时沟通解决您的问题和需求</span>
        </div>
        <span class="item-right">0571-89978775</span>
      </div>
      <div class="item">
        <div class="item-left">
          <span>商务对接</span>
          <span>如有合作意向请联系</span>
        </div>
        <span class="item-right">0571-89978771</span>
      </div>
      <p class="tip">工作时间：每周一至周五8:00-17:00</p>
    </el-dialog>
  </div>
</template>

<script>
  export default{
    name: 'zFooter',
    data () {
      return {
        contactUsVisible: false,
      }
    }
  }
</script>

<style scoped>
  .footer {
    position: relative;
    background: #fff;
    z-index: 99;
  }

  .footer .footer-contact {
    min-width: fit-content;
    background: url(/static/img/footer/bg_contact.png) no-repeat;
    background-size: cover;
  }

  .footer .footer-contact .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    padding: 40px 0;
    box-sizing: border-box;
  }

  .footer .footer-contact .content-left {
    display: flex;
    flex-direction: column;
    font-size: 22px;
    font-weight: 300;
    color: #fff;
    line-height: 32px;
    letter-spacing: 1.1px;
  }

  .footer .footer-contact .content-left span:first-of-type {
    display: inline-block;
    margin-bottom: 12px;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 1.6px;
  }

  .footer .footer-contact .content-right {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .footer .footer-contact .content-right-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 20px;
    width: 560px;
    background: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .footer .footer-contact .content-right-item .desc {
    flex: 1;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    color: #676767;
  }

  .footer .footer-contact .content-right-item .desc span:first-of-type {
    display: inline-block;
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }

  .footer .footer-contact .content-right-item button {
    padding: 6px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background: linear-gradient(180deg, #0069ff, #008cff);
    border-radius: 3px;
    box-sizing: border-box;
  }

  .footer .footer-top {
    padding: 40px 0;
    box-sizing: border-box;
  }

  .footer .footer-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 32px 0 40px 0;
    border-top: 1px solid #D9D9D9;
    border-bottom: 1px solid #D9D9D9;
    box-sizing: border-box;
  }

  .footer .footer-center .footer-content {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 40px 80px;
  }

  .footer .footer-center .footer-content-item {
    color: #333;
  }

  .footer .footer-center .footer-content-item .label {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.8px;
  }

  .footer .footer-center .footer-content-item .label .tip {
    display: inline-block;
    margin-left: 8px;
    font-size: 14px;
    font-weight: 400;
    color: #999;
    letter-spacing: 0.7px;
  }

  .footer .footer-center .footer-content-item .value {
    margin-top: 8px;
    font-size: 22px;
    font-weight: 300;
    letter-spacing: 1.1px;
    word-break: break-word;
  }

  .footer .footer-center .footer-code {
    display: flex;
    flex-direction: column;
    margin-left: 80px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    letter-spacing: 0.8px;
  }

  .footer .footer-center .footer-code img {
    display: inline-block;
    margin-bottom: 8px;
  }

  .footer .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 40px 0;
    box-sizing: border-box;
  }

  .footer .footer-bottom .footer-content {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 14px;
    font-weight: 300;
    color: #333;
    letter-spacing: 0.7px;
  }

  .footer .footer-bottom .footer-content>div {
    display: inline-flex;
    align-items: center;
  }

  .footer .footer-bottom .footer-content>div>img {
    display: inline-block;
    margin-right: 4px;
    margin-bottom: 2px;
  }

  .footer .footer-bottom .footer-service {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }

  .footer .footer-bottom .footer-service a {
    font-size: 14px;
    font-weight: 300;
    color: #999;
    letter-spacing: 0.7px;
  }

  .footer .footer-bottom .footer-service .divider {
    display: inline-block;
    margin: 0 20px;
    width: 1px;
    height: 14px;
    background: #d9d9d9;
  }
</style>

<style>
  .contact-us-dialog {
    background: linear-gradient(180deg,#eef7fc, #d2e7fc);
    border-radius: 5px;
    box-shadow: 0 8px 32px 0 rgba(0,41,101,0.16);
  }

  .contact-us-dialog .el-dialog__header {
    padding: 5px 20px 5px;
    background: transparent;
  }

  .contact-us-dialog .el-dialog__body .title {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 700;
    color: #333333;
    text-align: center;
  }

  .contact-us-dialog .el-dialog__body .desc {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #333;
    line-height: 24px;
  }

  .contact-us-dialog .el-dialog__body .desc + .desc {
    margin-top: 12px;
  }

  .contact-us-dialog .el-dialog__body .text-fill-blue {
    margin: 28px 0;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.5;
    color: transparent;
    background-image: linear-gradient(270deg, #32B4E5 0%, #4160FF 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
  }

  .contact-us-dialog .el-dialog__body .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 24px 20px;
    background: #f2f8ff;
    border-radius: 5px;
    box-shadow: 0 4px 16px 0 rgba(0,41,155,0.16);
    box-sizing: border-box;
  }

  .contact-us-dialog .el-dialog__body .item-left {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    color: #676767;
  }

  .contact-us-dialog .el-dialog__body .item-left span:first-of-type {
    display: inline-block;
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }

  .contact-us-dialog .el-dialog__body .item-right {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    letter-spacing: 1.2px;
  }

  .contact-us-dialog .el-dialog__body .tip {
    font-size: 14px;
    font-weight: 400;
    text-align: right;
    color: #676767;
    letter-spacing: 0.7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue